import { useState } from 'react';
import { PenLine } from '@trukt/ui/icons';
import { Typography } from '@trukt/ui/Typography';
import { Tooltip } from '@trukt/ui/Tooltip';
import { ReportNameProps } from './ReportName.types';
import { ReportNameForm } from './components';
import { useUpdateReportMutation } from '../../hooks';

export const ReportName = ({ reportName, reportId }: ReportNameProps) => {
  const [isEdit, setIsEdit] = useState(false);

  const updateReportMutation = useUpdateReportMutation();

  return (
    <div className="flex h-[1.8rem] gap-4">
      {isEdit ? (
        <ReportNameForm
          initialState={reportName}
          onSubmit={(updatedReportName) => {
            if (updatedReportName !== reportName) {
              updateReportMutation.mutate({
                body: {
                  name: updatedReportName,
                },
                routeParams: {
                  id: reportId,
                },
              });
            }
            setIsEdit(false);
          }}
        />
      ) : (
        <>
          <Tooltip title={reportName}>
            <div className="max-w-[5.2rem]">
              <Typography variant="h4" color="secondary">
                {reportName}
              </Typography>
            </div>
          </Tooltip>

          <div className="ml-auto">
            <PenLine
              role="img"
              aria-label="Edit report name"
              size="1.2rem"
              className="cursor-pointer fill-secondary-400 stroke-primary-400"
              onClick={() => setIsEdit(true)}
            >
              <title>Edit report name</title>
            </PenLine>
          </div>
        </>
      )}
    </div>
  );
};
